import * as swcHelpers from '@swc/helpers';
import { useState, useCallback, useMemo } from 'react';
import { Orders, ResponseError } from '@grandvisionhq/api-client';
import { useApiConfig } from '@grandvisionhq/state';
import { isNil, useInterval } from '@grandvisionhq/utils';
import { mapPaymentState } from '../../../mappers/payment-state.js';
import { errorsMapping } from '../../../mappers/errors-mapping.js';

/**
 * Continuously polls the backend for the payment state of the order
 * Polling will stop once an endstate is found. This can be either 'Paid' or 'Failed'
 *
 * There are two additional states called 'BalanceDue' and 'CreditOwed'. These are not used, but do require polling.
 *
 * The default polling interval is 5 seconds. This can be changed by setting the `pollInterval` option.
 */ const usePaymentState = (orderId, pollInterval = 5000)=>{
    const [state, setState] = useState(undefined);
    const [error1, setError] = useState();
    const routes = useApiConfig();
    const handler = useCallback(swcHelpers.asyncToGenerator(function*() {
        if (!orderId) {
            return;
        }
        try {
            const response = yield Orders.getPaymentState(routes.ordersUrl, {
                orderId
            });
            setState(mapPaymentState(response));
        } catch (error) {
            if (error instanceof ResponseError && error.statusCode === 404) {
                setError(errorsMapping.ORDER_NOT_FOUND);
            } else {
                setError(errorsMapping.SOMETHING_WENT_WRONG);
            }
        }
    }), [
        routes.ordersUrl,
        orderId
    ]);
    const options = useMemo(()=>({
            when: state !== 'Paid' && state !== 'Failed' && isNil(error1),
            startImmediate: true
        })
    , [
        state,
        error1
    ]);
    useInterval(handler, pollInterval, options);
    return [
        state,
        error1
    ];
};

export { usePaymentState };
//# sourceMappingURL=use-payment-state.js.map
